module.exports = __webpack_public_path__ + "static/media/contactIcon.95df7092.png";